import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ChangeEmailType } from "store/types/profile";

const initialChangeEmailState: ChangeEmailType = {
  email: "",
};

const changeEmailSlice = createSlice({
  name: "changeEmail",
  initialState: initialChangeEmailState,
  reducers: {
    setChangeEmail: (state, action: PayloadAction<ChangeEmailType>) => (state = action.payload),
  },
});

export const { setChangeEmail } = changeEmailSlice.actions;
export default changeEmailSlice.reducer;
